// extracted by mini-css-extract-plugin
export default {"container":"checkout_container__vQkPH","price":"checkout_price__AVCnq"};